import { sessionApiClient } from "@planningcenter/cc-api-client"
import {
  GivingPerson,
  Organization,
  PaymentMethod,
  Statement,
  Text2GivePhoneNumber,
} from "./types"
import { Fund } from "source/giving/donation_form/types"

export async function fetchGivingPerson(): Promise<GivingPerson> {
  const response = await sessionApiClient.get("/giving/v2/me")
  return response.data.attributes
}

export async function fetchText2GivePhoneNumber(): Promise<Text2GivePhoneNumber | null> {
  const response = await sessionApiClient.get(
    "/giving/v2/me/text_to_give_phone_number",
  )
  if (response.data) {
    const { attributes, relationships } = response.data
    return {
      id: response.data.id,
      phone_number: attributes.phone_number,
      payment_method_id: relationships?.payment_method?.data?.id ?? null,
    }
  } else {
    return null
  }
}

export async function fetchStatements(): Promise<Statement[]> {
  const response = await sessionApiClient.get("/giving/v2/me/statements")
  return response.data.map(
    (item: { id: string; attributes: Omit<Statement, "id"> }) => ({
      id: item.id,
      ...item.attributes,
    }),
  )
}

export async function fetchOrganization(): Promise<Organization> {
  const response = await sessionApiClient.get("/giving/v2")
  return {
    id: response.data.id,
    ...response.data.attributes,
  }
}

export async function fetchFunds(): Promise<Fund[]> {
  const response = await sessionApiClient.get("/giving/v2/funds")
  return response.data.map(
    (item: { id: string; attributes: Omit<Fund, "id"> }) => ({
      id: item.id,
      ...item.attributes,
    }),
  )
}

export async function fetchPaymentMethods(): Promise<PaymentMethod[]> {
  const response = await sessionApiClient.get("/giving/v2/me/payment_methods")
  return response.data.map(
    (item: { id: string; attributes: Omit<PaymentMethod, "id"> }) => ({
      id: item.id,
      ...item.attributes,
    }),
  )
}
